export const baoCao = {
  invalid: '报表无效',
  moiQuanTam: '关注点',
  loaiBaoCao: '报表类型',
  thoiGian: '时间',
  empty: '暂无报表数据',
  chartTitle: '图表',
  chartEmpty: '暂无图表数据',
  hideChart: '隐藏图表',
  showChart: '显示图表',
  giaiThich: {
    nut: '计算说明',
    tieuDe: '数据计算方式',
    tenKhac: '列表视图：{ten}',
    dong: '关闭',
  },
  range: '从 {tu} 至 {den}',
  dateRangePlaceholder: '选择日期范围',
  fromDate: '开始日期',
  toDate: '结束日期',
  maGiaoDich: '交易编码',
  maHangHoa: '商品编码',
  tenHangHoa: '商品名称',
  filter: {
    searchPlaceholder: '搜索单据、商品代码/名称、客户',
    textDetailTitle: '详细筛选',
  },
  aria: {
    columnPicker: '调整列',
  },
  reports: {
    tongHop: '汇总报表',
    doanhThuLn: '营收、利润',
    tonKho: '库存报表',
    topSale: '畅销',
    topMua: '客户购买排行',
  },
  tongCong: '总计',
  loiTai: '无法加载报表：{msg}',
  concernGroups: {
    tongHop: '汇总',
    soSanhKy: '期间对比',
    thangChiNhanh: '月 × 分店',
    margin: '毛利与利润',
  },
  concernsShort: {
    khach: '按客户',
    sanPham: '按商品',
    nhom: '按商品组',
    khachSp: '按客户 + 商品',
    mgKhach: '业务员 + 客户',
    mgNhom: 'KPI组 + 业务员',
    lnThang: '月利润率',
  },
  bangChiTiet: '明细表',
  hienThi: { title: '显示方式', PIVOT: '透视表', DS: '列表' },
  soDong: '{n} 行',
  truncated: '仅显示前 2,000 行。请缩小日期或筛选条件以查看全部。',
  concerns: {
    banHang: '销售',
    thuChi: '收支',
    hangHoa: '商品',
    tongHop: '汇总',
    thoiGian: '时间',
    loiNhuan: '利润',
    giamGiaHd: '单据优惠',
    traHang: '退货',
    nhanVien: '员工',
    chiNhanh: '分店',
    giaoDich: '交易',
    giaTriKho: '库存价值',
    xuatNhapTon: '进销存',
    xuatHuy: '报废',
    congNo: '往来',
    nhapHang: '进货',
    chiTietHd: '发票明细',
    soSanhKy: '期间对比',
    chiTietNgan: '明细',
    soSanhNgan: '对比',
    thangNhom: '月份 + 品类',
    nvkdNhom: '业务员 + 月份 + 品类',
    nvkdKhach: '业务员 + 月份 + 客户',
    khachThang: '客户 + 月份',
    tonNgay: '每日库存',
    tonKy: '期间库存',
    tonGiaoDich: '进出明细',
    tonGoiY: '滞销 + 补货建议',
    tonGoiYGop: '补货建议（合并分店）',
    topSanPham: '按商品',
    topToanBo: '合并全部范围',
    topTungMang: '各业务线内',
    topTungChiNhanh: '各分店内',
    topChiNhanh: '按商品 + 分店',
    ssKhach: '按客户期间对比',
    ssSanPham: '按商品期间对比',
    ssNhom: '按商品组期间对比',
    pvSanPham: '月 × 分店（按商品）',
    pvKhach: '月 × 分店（按客户）',
    pvKhachSp: '月 × 分店（按客户 + 商品）',
    mgKhach: '毛利率（按业务员 + 客户）',
    mgNhom: '毛利率（按KPI组 + 业务员）',
    lnThang: '月利润率（按KPI组 + 分店）',
  },
  kpi: {
    dt: '净营收',
    ln: '利润',
    margin: '% 毛利率',
    sl: '数量',
    so: '对比',
    thamChieu: '参考',
    diemPct: '个百分点',
  },
  charts: {
    trend: '月度趋势',
    top: '{metric} 前 {n}',
    coCau: '{metric} 按 {dim} 构成',
    theoKy: '各期间营收与利润',
    topKy: '{nhan} 营收前 {n} 与各期间对比',
    khac: '其他',
  },
  soSanh: {
    kySection: '对比期间',
    kieuKy: '期间类型',
    luyKeNgan: '累计',
    kieuKyOptions: {
      THANG: '月',
      QUY: '季度',
      NAM: '年',
      N_THANG: '多个月',
      LUY_KE: '年初至今',
      TUAN: '周',
      TUY_CHON: '自定义',
    },
    denThang: '截至月份',
    nam: '年',
    quy: '季度',
    thang: '月',
    tuThang: '起始月',
    tuNgan: '从',
    denNgan: '至',
    soThang: '月数',
    soThangValue: '{n} 个月',
    tuan: '周',
    tuyChon: {
      loai: { THANG: '月', QUY: '季度', NAM: '年', TUAN: '周', NGAY: '日期范围' },
      loaiNgan: { THANG: '月', QUY: '季度', NAM: '年', TUAN: '周', NGAY: '日期' },
      kyGoc: '基准期',
      kyN: '期间 {n}',
      themKy: '添加期间',
      xoaKy: '删除期间',
      tuanShort: '第 {n} 周',
    },
    chiNhanhSection: '分店',
    tachChiNhanh: '按分店拆分',
  },
  phamVi: {
    duAnSection: '项目',
    duAnMacDinh: '当前项目',
    duAnEmpty: '没有项目',
    chonTatCa: '全选',
    boChonTatCa: '取消全选',
    chonNhanh: '快速选择范围',
    toanHeThong: '整个系统',
    mangDangDung: '当前业务线',
    chiNhanhDangDung: '当前分店',
    section: '范围',
    heThongNgan: '系统',
    mangNgan: '业务线',
    chiNhanhNgan: '分店',
  },
  topSale: {
    section: '排行选项',
    xepHang: '排行方式',
    xepHangNgan: { TOAN_BO: '全部范围', TUNG_MANG: '按业务线', TUNG_CHI_NHANH: '按分店' },
    tieuChi: '排序依据',
    tieuChiOptions: { DOANH_THU: '收入', SO_LUONG: '数量', LOI_NHUAN: '利润' },
    soTop: '显示前',
    soTopValue: '前 {n}',
    kieuXep: '计算方式',
    kieuXepOptions: { KY: '整个期间', THANG: '逐月' },
    kieuXepHint: {
      KY: '汇总整个日期范围后排行。',
      THANG: '逐月分别排行，统计商品进入前列的月数。',
    },
    tomTat: {
      top: '按{tieuChi}前 {n}',
      phan: {
        TOAN_BO: '整体合并',
        TUNG_MANG: '各业务线内排行',
        TUNG_CHI_NHANH: '各分店内排行',
      },
      soMang: '{n} 个业务线',
      soChiNhanh: '{n} 个分店',
      tatCaChiNhanh: '全部分店',
    },
    kpi: {
      soSp: '上榜商品数',
      soKh: '上榜客户数',
      soHd: '发票数',
      sl: '净销量',
      dtTruocTra: '收入',
      traHang: '退货',
    },
  },
  tonKho: {
    kpi: {
      soMa: '商品数',
      soPhieu: '单据数',
      tonDau: '期初库存',
      nhap: '期内入库',
      xuat: '期内出库',
      tonCuoi: '期末库存',
      bienDong: '库存变动',
      chenhLech: '入库 − 出库',
      doanhSo: '期内销售额',
      gp: '毛利',
      nonmoving: '滞销商品',
      tonCao: '库存过高商品',
      canDat: '需补货商品（30天）',
      choGiao: '待交付',
    },
    sub: {
      sl: '数量 {v}',
      slBan: '销量 {v}',
      slDat: '建议 {v}',
      fm: 'FM {v}',
      giaTri: '金额 {v}',
    },
  },
  luu: {
    nutLuu: '保存',
    nutDaLuu: '已保存',
    tieuDe: '保存报表',
    suaTieuDe: '编辑已保存报表',
    trangTieuDe: '已保存报表',
    luu: '保存',
    huy: '取消',
    sua: '编辑',
    xoa: '删除',
    boGhim: '取消置顶',
    dangLuu: '正在保存…',
    dangChup: '正在抓取数据…',
    daLuu: '已保存「{ten}」',
    daXoa: '已删除保存的报表',
    xemDanhSach: '查看列表',
    xemTatCa: '查看全部已保存报表',
    chuaCo: '暂无已保存的报表',
    moTaPhamVi: '期间：{ky}',
    soBang: '{n} 个数据表',
    ghimMoTa: '置顶的快照不会在 180 天后过期。',
    taiExcel: '下载 Excel',
    chayLai: '用最新数据重新运行',
    tatCaThoiGian: '全部时间',
    chiBanChup: '仅适用于快照报表',
    khongCoQuyenSua: '您无权编辑此报表',
    moBanChup: '打开快照',
    moBoLoc: '用已保存的筛选打开',
    daHetHan: '已过期',
    khongHetHan: '永不过期',
    biCat: '保存时数据已被截断',
    xuLyTrong: '耗时 {s} 秒',
    chiCuaToi: '仅我的报表',
    cuaToi: '我的',
    tatCaLoai: '全部报表',
    tatCaKieu: '全部',
    timKiem: '搜索',
    timKiemPlaceholder: '按报表名称、备注搜索',
    xacNhanXoa: '删除已保存报表「{ten}」？快照数据也将被删除。',
    boLocBiKhoa: '正在查看快照 — 点击「用最新数据重新运行」以更改筛选',
    khongCoTrongBanChup: '快照中没有该配置的数据。点击「用最新数据重新运行」重新查询。',
    kieu: {
      BAN_CHUP: '数据快照',
      BO_LOC: '仅筛选条件',
    },
    kieuMoTa: {
      BAN_CHUP: '保存当前的数据，可按保存时的样子查看和导出 Excel。',
      BO_LOC: '只保存筛选条件，重新打开时使用最新数据。',
    },
    chiaSe: {
      CA_NHAN: '仅自己',
      DU_AN: '项目内所有人',
    },
    truong: {
      ten: '名称',
      ghiChu: '备注',
      kieu: '保存方式',
      chiaSe: '共享',
      ghim: '置顶',
      loaiBaoCao: '报表',
      khoangNgay: '日期范围',
      thoiGianTruyVan: '查询时间',
      soDong: '行数',
      nguoiLuu: '保存人',
      hetHan: '过期',
      boLoc: '筛选',
      tenBaoCao: '报表名称',
      tuNgay: '开始日期',
      denNgay: '结束日期',
      thoiGianXuLy: '处理时间',
      kichThuoc: '大小',
      ngayTao: '保存时间',
      trangThai: '状态',
      thaoTac: '操作',
    },
    soGiay: '{s} 秒',
    conHan: '有效',
    anHienCot: '显示/隐藏列',
    ngan: {
      reports: {
        doanhThuLn: '营收利润',
        tonKho: '库存',
        topSale: '畅销',
        topMua: '客户购买',
      },
      concerns: {
        chiTietHd: '明细',
        soSanhKy: '对比',
        giamGiaHd: '折扣',
        xuatNhapTon: '进销存',
        tonNgay: '每日',
        tonKy: '按期',
        tonGiaoDich: '出入库',
        tonGoiY: '补货建议',
        topTungMang: '按业务线',
        topTungChiNhanh: '按分店',
      },
    },
    banner: {
      dangTai: '正在加载快照…',
      loi: '无法打开快照：{msg}',
      dangXem: '正在查看快照「{ten}」',
      truyVanLuc: '数据时间 {tg}',
      nguoiLuu: '保存人：{ten}',
    },
    excel: {
      sheetThongTin: '信息',
      pivot: '透视',
    },
  },
  pivot: {
    title: '数据透视表',
    titleDs: '列表',
    mauLabel: '模板：',
    tuyChinh: '自定义',
    moCap: '展开到级别',
    thuGon: '折叠',
    truncated: '数据过多，仅汇总前 {n} 行。请缩小时间、范围或减少字段。',
    nhieuDong: '仅显示前 {n} 行 — 折叠部分分组以查看其余。',
    nhieuDongDs: '仅显示前 {n} 行 — 请缩小筛选范围以查看其余。',
    soNhom: '{n} 个一级分组',
    chonGiaTri: '请在“指标”中至少选择一个指标。',
    sapTheoNhan: '点击按名称排序',
    sapTheoCot: '点击按此列排序（降序 → 升序 → 取消）',
    thang: '{n}月',
    quy: '第{n}季度',
    tongCua: '{label} 合计',
    timTruong: '搜索字段 / 指标',
    tongPhuCot: '为每个列分组显示小计列',
    giaTriTruoc: '按指标分组列',
    giaTriTruocMoTa: '列标题：指标在上，期间在下（指标 › 期间）',
    nhomTheo: '分组依据',
    dongTheoCap: '按层级分行',
    giaTriSection: '数值',
    chiaCot: '按列拆分',
    chiSoNut: '指标',
    soChiSo: '{n} 个指标',
    khongChon: '无',
    sapXep: '排序',
    sapMacDinh: '默认',
    sapNhanTang: '按名称 A → Z',
    sapNhanGiam: '按名称 Z → A',
    giamDan: '降序',
    tangDan: '升序',
    motCot: '单列',
    themLoc: '添加筛选',
    locTatCa: '全部',
    locRong: '未选择',
    locSo: '{n}/{m}',
    lenTren: '上移',
    xuongDuoi: '下移',
    stt: '序号',
    boMuc: '移除',
    themCap: '添加行层级…',
    themChiSo: '添加数值…',
    themTatCa: '全部添加',
    boHet: '全部清除',
    khongTimThay: '无匹配项',
    chuaChonCap: '未选择层级 — 仅显示合计行。',
    chuaChonChiSo: '未选择数值。',
    locGiaTri: {
      title: '筛选值',
      tim: '搜索值',
      chonTatCa: '全选',
      boChon: '取消全选',
      conNua: '还有 {n} 个值 — 输入以搜索',
      dangChon: '已选 {n}/{m}',
      xoaLoc: '清除筛选',
      xong: '完成',
    },
    mau: {
      hoaDon: '日 + 业务员（本月）',
      tongHop: '按年汇总',
      thangNhom: '月 + 商品组',
      nvkdNhom: '销售 + 月 + 商品组',
      nvkdKhach: '销售 + 月 + 客户',
      khachThang: '客户 × 月（横向）',
      thangChiNhanh: '月 × 分店',
      marginKhach: '毛利（销售 + 客户）',
      ssNhomHang: '商品组 › 商品',
      ssNvkdNhom: '销售 › 商品组 › 商品',
      ssNvkdKhach: '销售 › 客户',
      ssKhachHang: '客户 › 商品',
      tonNgay: '每日库存',
      tonKy: '按分店库存',
      tonThang: '每月末库存',
      tonGiaTri: '库存金额',
      gdDoc: '按日出入库',
      gdLoaiPhieu: '按单据类型（横向）',
      gdHuong: '入/出 × 单据类型',
      goiYNhom: '全部商品',
      chiNonmoving: '仅呆滞',
      goiYChiNhanh: '按分店',
    },
    truong: {
      nam: '年',
      quy: '季度',
      thang: '月',
      ngay: '日',
      thangNam: '月/年',
      ngayDayDu: '日期',
      mang: '项目',
      chiNhanh: '分店',
      nvkd: '销售员',
      nhom1: '一级分组',
      nhom2: '二级分组',
      nhom3: '三级分组',
      nhom: '分组（3级）',
      hang: '商品编码 - 名称',
      khach: '客户编码 - 名称',
      cuMoi: '新 / 老客户',
      maHd: '发票号',
      tinh: '省 / 市',
      phuong: '坊 / 社',
      kySs: '期间',
      huong: '入 / 出',
      loai: '单据类型',
      maPhieu: '单据号',
      nonmoving: '呆滞',
      tinhTrang: '状态',
      noteTop: '畅销备注',
      dangKd: '在售',
    },
    chiSo: {
      sl: '数量',
      slTbThang: '月均数量',
      doanhThu: '营收',
      giamGia: '折扣',
      thuKhac: '其他收费',
      vat: '增值税',
      traHang: '退货',
      dtThuan: '净营收',
      giaVon: '成本',
      loiNhuan: '利润',
      lnTrenVon: '% 利润/成本（加价率）',
      margin: '% 利润/营收（毛利率）',
      tyTrong: '% 营收占比',
      xepHang: '营收排名',
      soKg: '公斤',
      soKhoi: '体积',
      tonDau: '期初数量',
      gtDau: '期初金额',
      kgDau: '期初公斤',
      khoiDau: '期初体积',
      slNhap: '入库数量',
      gtNhap: '入库金额',
      slXuat: '出库数量',
      gtXuat: '出库金额',
      tonCuoi: '期末数量',
      gtCuoi: '期末金额',
      kgCuoi: '期末公斤',
      khoiCuoi: '期末体积',
      slPs: '发生数量',
      gtPs: '发生金额',
      tonBq: '平均库存',
      vongQuay: '周转率',
      roii: 'ROII',
      slBan: '销售数量',
      doanhSo: '销售额',
      gp: '毛利',
      fm: '% FM',
      slYoy: '同期数量',
      dtYoy: '同期营收',
      slCho: '待发数量',
      gtCho: '待发金额',
      goiY30: '建议订货 30 天',
      goiY60: '建议订货 60 天',
    },
    giaTriTruong: {
      moi: '新客户',
      cu: '老客户',
      nhap: '入库',
      xuat: '出库',
      nonmoving: '呆滞',
      binhThuong: '正常',
      tonCao: '库存过高',
      nonmovingTonCao: '呆滞，库存过高',
      topSale: '畅销',
      khac: '其他',
      dangKd: '在售',
      ngungKd: '停售',
      NHAP_MUA: '采购入库',
      NHAP_CHUYEN: '调拨入库',
      NHAP_TRA_HANG: '退货入库',
      NHAP_DIEU_CHINH: '调整入库',
      NHAP_KHAC: '其他入库',
      XUAT_BAN: '销售出库',
      XUAT_CHUYEN: '调拨出库',
      XUAT_TRA_NCC: '退供应商',
      XUAT_HUY: '报废出库',
      XUAT_NOI_BO: '内部出库',
      XUAT_DIEU_CHINH: '调整出库',
      XUAT_KHAC: '其他出库',
      KIEM_KE: '盘点',
      kiemKe: '盘点',
    },
  },
}
